/**
 * Normalize mention markup to plain @Name text for widget rendering.
 *
 * The dashboard reply composer emits two mention formats that need to survive
 * round-trip into the widget thread:
 *   1. TipTap HTML:  <span ... data-mention-user="ULID" ...>@Name</span>
 *   2. Plaintext:    @[Name](user:ULID)
 *
 * The widget renders replies as React text nodes (no HTML parsing, no TipTap)
 * so without this helper customers see literal span markup or markdown-style
 * brackets. Strip both forms down to a bare "@Name" — the ULID is internal
 * plumbing and has no display value on the customer side.
 */

const PLAINTEXT_MENTION = /@\[([^\]]+)\]\(user:[0-9A-HJKMNP-TV-Z]{26}\)/gi

const HTML_MENTION = /<span[^>]*data-mention-user=["'][0-9A-HJKMNP-TV-Z]{26}["'][^>]*>([^<]*)<\/span>/gi

export function normalizeMentionsForDisplay(body: string | null | undefined): string {
  if (!body) return ''
  return body
    .replace(HTML_MENTION, (_, label: string) => label.trim() || '@')
    .replace(PLAINTEXT_MENTION, (_, label: string) => `@${label}`)
}
